<template>
  <div class="chat-popup">
    <DxPopup
      width="80vw"
      height="90vh"
      v-model:visible="isChatOverviewVisible"
      :hide-on-outside-click="false"
    >
      <DxToolbarItem
        widget="dxButton"
        :options="buttonOptions"
        location="after"
      >
      </DxToolbarItem>
      <template #content>
        <div class="chat-container">
          <DxChat
            :items="messages"
            :user="currentUser"
            :showAvatar="true"
            :showUserName="true"
            :showDayHeaders="true"
            :showMessageTimestamp="true"
            :dayHeaderFormat="'dd/MM/yyyy'"
            :messageTimestampFormat="'hh:mm a'"
            message-template="message"
            class="chat-content"
            empty-view-template="empty-view-template"
            ><template #message="{ data }">
              <div
                class="chat-message-text"
                v-html="renderMessage(data.message)"
              ></div>
            </template>
            <template #empty-view-template="{ data }">
              <div>{{ data.texts.message }}</div>
            </template>
          </DxChat>
        </div>
      </template>
    </DxPopup>
  </div>
</template>
<script setup>
import { computed } from "vue";
import store from "../../../store/index";
import MarkdownIt from "markdown-it";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import { DxChat } from "devextreme-vue/chat";

const md = new MarkdownIt({
  html: true,
  linkify: true,
  breaks: true
});

const buttonOptions = {
  icon: "close",
  onClick: e => store.commit("aiAssistantLogs/closeChatOverviewPopup")
};

const renderMessage = message => {
  if (!message || !message.text) return "";

  return md.render(message.text);
};

const messages = computed(
  () => store.state.aiAssistantLogs.messagesFromSelectedConversation
);
const currentUser = computed({
  get: () => store.state.aiAssistantLogs.currentUser
});
const isChatOverviewVisible = computed(
  () => store.state.aiAssistantLogs.isChatOverviewVisible
);
</script>
